import React from "react";
import { SectionHeader } from "../components/SiteUI";
import styles from "./StorePage.module.scss";

export default function StorePage() {
  const content = {
    title: "Coming Soon",
    body:
      "We’re putting the final touches on our store experience.\nCheck back soon for gear, accessories, and more.",
  };

  return (
    <section className={styles.page} title="Store">
      <SectionHeader title={<h2>Store</h2>} />
      <div className={styles.divider} />
      <div className={styles.comingSoon}>
        <div className={styles.comingSoonCard}>
          <h3>{content.title}</h3>
          <p>{content.body}</p>
        </div>
      </div>
    </section>
  );
}
